import { AxiosResponse } from "axios";
import SucessDataService from "../services/SuccessDataService";
import ProfessionalAttachmentService from "../services/ProfessionalAttachmentService";
import ProfissionalService from "../services/ProfessionalService";
import FormBase from "../forms/FormBase";
import { FieldAttachment } from "../forms/FormFieldAttachmentBase";
import Professional from "../models/Professional";
import LogService from "../services/LogService";

export enum EAttachmentType {
    CorpoClinico = 1,
    AutorizacaoEspecial = 2,
    MedicoAssistente = 3,
    MedicoParceiro = 4,
    Multiprofissional = 5,
    Recadastramento = 6,
    MedicoTerceiro = 7,
}

const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 1000;


//Método que avança as etapas e apreseta uma mensagem de erro quando houver
const goToNextStepWithLoading = (dispatch: any, messagesError: string[], showLoading: boolean) => {

    dispatch({
        type: "GO_TO_NEXT_STEP",
        payload: { messagesError: messagesError },
    });

    dispatch({
        type: "LOADING",
        payload: {
            processing: showLoading
        },
    });
};

//Método responsavel por criar um profissional caso ele não exista no state.
//Quando o profissional existir no state, ele é retornado
const createOrGetProfessionalDefault = async (dispatch: any, state: any) => {

    let localProfessional = Professional.NewInstance();

    if (state.Professional === null || state.Professional.Id === "" || state.Professional.Id === null) {

        if (state.PersonalDataForm.ValidateToGoNextStep() === "") {
            try {
                const response = await ProfissionalService.postInsertOrUpdateProfissional(state.PersonalDataForm.getJsonObjet(), "");

                localProfessional = new Professional(response.encriptId, response.name);

                dispatch({
                    type: "SET_PROFESSIONAL",
                    payload: {
                        response: response
                    },
                });

            } catch (error: any) {
                goToNextStepWithLoading(dispatch, [error.response.data], false);
            }
        }
    } else {
        localProfessional = state.Professional;
    }

    return localProfessional;
};

//Método responsavel por criar um profissional do tipo Autorização especial caso ele não exista no state.
//Quando o profissional existir no state, ele é retornado
const createOrGetProfessionalSpecialauthorization = async (dispatch: any, state: any) => {

    let localProfessional = Professional.NewInstance();

    if (state.Professional === null || state.Professional.Id === "" || state.Professional.Id === null) {

        if (state.PersonalDataForm.ValidateToGoNextStep() === "") {
            try {
                const response = await ProfissionalService.postInsertOrUpdateProfissionalSpecialauthorization(state.PersonalDataForm.getJsonObjet(), "");

                localProfessional = new Professional(response.encriptId, response.name);

                dispatch({
                    type: "SET_PROFESSIONAL",
                    payload: {
                        response: response
                    },
                });

            } catch (error: any) {
                goToNextStepWithLoading(dispatch, [error.response.data], false);
            }
        }
    } else {
        localProfessional = state.Professional;
    }

    return localProfessional;
};


//Método responsável por apresentar ou não o ícone de loading
const callInsertOrUpdateApiForms = (steps: any[], state: any, professional: Professional, dispatch: any, getForm: (name: string, state: any) => {}) => {

    try {

        var formMessagesError = new Array<string>();

        steps.forEach(function (stepConfig) {
            if (stepConfig.key === state.CurrentStep) {
                stepConfig.steps.forEach(function (step: any) {
                    var form = getForm(step.name, state) as FormBase;
                    let message = form.ValidateToGoNextStep(state);
                    if (message !== "" && ((formMessagesError.length === 0 && !stepConfig.validateAllForms) || stepConfig.validateAllForms)) {
                        formMessagesError.push(message);
                    }
                });
            }
        });

        // Caso o formulário não tenha nenhum erro, o sistema chama as APIs vinculadas a cada formulário
        if (formMessagesError.length === 0) {

            steps.forEach(function (step: any) {

                if (step.key === state.CurrentStep) {
                    let promises: any[] = [];

                    step.steps.forEach(async function (step: any) {
                        var form = getForm(step.name, state) as FormBase;
                        promises.push(form.CallInsertOrUpdateApi(professional));
                    });

                    Promise.all(promises).then(async () => {

                        //Ultima Etapa
                        if (state.CurrentStep === steps.length) {

                            const response = await SucessDataService.postFinishForm(professional.Id);

                            dispatch({
                                type: "LOADING",
                                payload: {
                                    processing: false
                                },
                            });


                            dispatch({
                                type: "SET_PROTOCOL",
                                payload: {
                                    response: response
                                },
                            });

                        } else {
                            dispatch({
                                type: "GO_TO_NEXT_STEP",
                                payload: {
                                    messagesError: []
                                },
                            });

                            dispatch({
                                type: "LOADING",
                                payload: {
                                    processing: false
                                },
                            });
                        }
                    })
                        .catch((errors) => {
                            dispatch({
                                type: "GO_TO_NEXT_STEP",
                                payload: {
                                    messagesError: [errors.response.data]
                                },
                            });

                            dispatch({
                                type: "LOADING",
                                payload: {
                                    processing: false
                                },
                            });
                        });
                }
            });
        } else {
            dispatch({
                type: "GO_TO_NEXT_STEP",
                payload: {
                    messagesError: formMessagesError
                },
            });

            dispatch({
                type: "LOADING",
                payload: {
                    processing: false
                },
            });
        }
    } catch (error) { }

};

//Método responsavel por delete um arquivo
const deleteFile = async (dispatch: any, file: FieldAttachment, name: string, form: FormBase) => {

    if (file.Id === "") {
        dispatch({
            type: "UPDATE_FORM_ATTACHMENT",
            payload: {
                name,
                form,
                value: file,
                subType: "Delete",
                id: file.Id,
            },
        });
    } else {

        dispatch({
            type: "UPDATE_FORM_ATTACHMENT",
            payload: {
                name,
                form,
                value: file,
                subType: "Loading",
                loading: true,
                id: file.Id,
            },
        });


        await ProfessionalAttachmentService.deleteAttachment(file.Id)
            .then((success) => {
                dispatch({
                    type: "UPDATE_FORM_ATTACHMENT",
                    payload: {
                        name,
                        form,
                        value: file,
                        subType: "Delete",
                        id: file.Id,
                    },
                });

                dispatch({
                    type: "UPDATE_FORM_ATTACHMENT",
                    payload: {
                        name,
                        form,
                        value: file,
                        subType: "Loading",
                        loading: false,
                        id: file.Id,
                    },
                });
            })
            .catch((error) => {
                dispatch({
                    type: "UPDATE_FORM_ATTACHMENT",
                    payload: {
                        name,
                        form,
                        value: file,
                        subType: "Error",
                        errorMessage: error.response !== undefined ? error.response.data : "Não foi possível deletar o arquivo.",
                    },
                });

                dispatch({
                    type: "UPDATE_FORM_ATTACHMENT",
                    payload: {
                        name,
                        form,
                        value: file,
                        subType: "Loading",
                        loading: false,
                        id: file.Id,
                    },
                });
            });
    }
};


//Método responsavel por realizar o upload de um arquivo
const updateloFile = async (dispatch: any, professional: Professional, formData: FormData, file: FieldAttachment, name: string, form: FormBase, typeAttachment: EAttachmentType) => {

    try {
        await LogService.postInsertLog(professional.Id, `Realizando o upload do arquivo para o profissional ${file.File?.name} - ${file.File?.size} - ${file.File?.type} - ${name}`, false, true);
    } catch (logError) {
        console.error("Erro ao registrar log:", logError);
    }

    if (!professional || !professional.Id) return;

    const promiseFn = getAttachmentUpdatePromise(typeAttachment);

    dispatch({
        type: "LOADING",
        payload: { processing: false },
    });

    try {
        const response = await uploadWithRetry(promiseFn, formData, professional.Id);
        file.Id = response.data.encriptId;

        dispatch({
            type: "UPDATE_FORM_ATTACHMENT",
            payload: {
                name,
                form,
                value: file,
                subType: "UpdateId",
                id: file.Id,
            },
        });
    } catch (error: any) {
        const isUnknownError = !error.response || !error.response.data;

        if (isUnknownError) {
            try {
                await LogService.postInsertLog(professional.Id, `Erro ao realizar o upload do arquivo: ${error}`, false, true);
            } catch (logError) {
                console.error("Erro ao registrar log:", logError);
            }
        }

        dispatch({
            type: "UPDATE_FORM_ATTACHMENT",
            payload: {
                name,
                form,
                value: file,
                subType: "Error",
                errorMessage: error.response?.data || "Não foi possível executar o upload do arquivo. Por favor, clique na lixeira para remover o arquivo. Em seguida, tente novamente. Se o erro persistir, entre em contato com o SAM – Serviço de Apoio ao Médico.",
            },
        });
    }
};



const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const getAttachmentUpdatePromise = (typeAttachment: EAttachmentType): (data: FormData, professionalId: string) => Promise<AxiosResponse<any>> => {
    switch (typeAttachment) {
        case EAttachmentType.CorpoClinico:
            return ProfessionalAttachmentService.updateProfessionalAttachmentClinicalStaff;
        case EAttachmentType.AutorizacaoEspecial:
            return ProfessionalAttachmentService.updateProfessionalAttachmentSpecialAuthorization;
        case EAttachmentType.MedicoAssistente:
            return ProfessionalAttachmentService.updateProfessionalAttachmentAssistantDoctor;
        case EAttachmentType.MedicoParceiro:
            return ProfessionalAttachmentService.updateProfessionalAttachmentMedicoParceiro;
        case EAttachmentType.Multiprofissional:
            return ProfessionalAttachmentService.updateProfessionalAttachmentMultiprofissional;
        case EAttachmentType.MedicoTerceiro:
            return ProfessionalAttachmentService.updateProfessionalAttachmentMedicalServiceProvider;
        default:
            throw new Error("Tipo de anexo inválido.");
    }
};

const uploadWithRetry = async (promiseFn: (data: FormData, professionalId: string) => Promise<AxiosResponse<any>>, formData: FormData, professionalId: string): Promise<AxiosResponse<any>> => {
    let attempt = 0;
    while (attempt < MAX_RETRIES) {
        try {
            return await promiseFn(formData, professionalId);
        } catch (error: any) {
            attempt++;

            const isUnknownError = !error.response || !error.response.data;

            if (!isUnknownError || attempt === MAX_RETRIES) {

                try {
                    await LogService.postInsertLog(professionalId, `Erro ao realizar o upload do arquivo: ${error}`, false, true);
                } catch (logError) {
                    console.error("Erro ao registrar log:", logError);
                }

                throw error;
            }
            else
            {
                try {
                    await LogService.postInsertLog(professionalId, `Ocorreu um erro não tratado no upload do arquivo. O Processo de Retry será acionado.: ${error}`, false, true);
                } catch (logError) {
                    console.error("Erro ao registrar log:", logError);
                }

            }

            // Aguarda antes de tentar novamente
            await sleep(RETRY_DELAY_MS);
        }
    }

    // Nunca deveria chegar aqui, pois erro será lançado no catch acima.
    throw new Error("Flaha desconhecida após múltiplas tentativas.");
};


//Método responsável por apresentar ou não o ícone de loading
const setLoading = (dispatch: any, showLoading: boolean) => {

    dispatch({
        type: "LOADING",
        payload: {
            processing: showLoading
        },
    });
};




const exportedObject = {
    goToNextStepWithLoading,
    createOrGetProfessionalDefault,
    createOrGetProfessionalSpecialauthorization,
    callInsertOrUpdateApiForms,
    setLoading,
    deleteFile,
    updateloFile
};


export default exportedObject